module.exports = __webpack_public_path__ + "static/media/web-dev-sanity.6afde1e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web-dev-sanity.png
// module id = 39
// module chunks = 0